import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '999em',
        background: colorsPalette.whiteSecondary,
        height: 48,
        paddingLeft: 25,
        paddingRight: 9,
        position: 'relative',
        cursor: 'pointer',
      },
    },
    wrapperOpen: {
      position: 'relative',
      background: colorsPalette.whiteSecondary,
      borderRadius: '999em',
      height: 48,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 25,
      paddingRight: 9,

      [theme.breakpoints.up('sm')]: {
        width: 400,
      },
    },
    input: {
      '& input::placeholder': {
        color: colorsPalette.white,
      },
    },
    searchPlaceholder: {
      marginRight: SMALL_MARGIN,
      fontSize: 16,
      display: 'none',
      [theme.breakpoints.up('lg')]: {
        display: 'block',
      },
    },
    closeIconWrapper: {
      position: 'absolute',
      left: -50,
      top: '50%',
      transform: 'translateY(-50%)',

      '& svg': {
        width: 20,
        height: 20,
      },
    },
    inputWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    searchIcon: {
      width: 18,
      height: 18,
    },
  });
});

export default useStyles;
